import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomHeightInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomHeightInput = React.memo(
  ({ className, hideLabel }: RoomHeightInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.height"
        className={classNames("room-form__height", className)}
        label={t("Room.height")}
        unit="m"
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 2 }}
        step={0.1}
        data-testid="room__height__input"
      >
        {!hideLabel && <NumberInput.Label showUnit />}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
